// import { useEffect, useState } from 'react';
import GroupService from 'services/GroupService';
import TeacherService from 'services/TeacherService';
import UserService from 'services/UserService';

const userService = UserService.getInstance();
const groupService = GroupService.getInstance();
const teacherService = TeacherService.getInstance();

function useTeacher() {
  // TODO: Normalize these functions to avoid confusion

  const getTeachers = async () => {
    const res = await userService.fetchCenterTeachers();
    return res;
  };

  const addTeachers = async (teachers: any[], _centerId: any) => {
    const res = await userService.addTeacher(teachers, _centerId);
    return res;
  };

  const getTeacherList = (centerID: number, groupID: number) =>
    groupService.getTeacherbyGroup(centerID, groupID);

  const editTeacher = async (
    teacher: any[],
    _centerId: any,
    teacherId: any,
  ) => {
    const res = await userService.editTeacher(teacher, _centerId, teacherId);
    return res;
  };

  const deleteTeacher = async (_centerId: any, teacherId: any) => {
    const res = await userService.deleteTeacher(_centerId, teacherId);
    return res;
  };


  const addTeacher = (body: any, centerId: number) => teacherService.postTeacher(body, centerId);

  const updateTeacher = (body: any, centerId: number, teacherId: number) => teacherService.putTeacher(body, centerId, teacherId);
  
  const moveTeachers = ({
    teachers = [],
    sendToCenter,
    centerId,
  }: {
    teachers: number[];
    centerId: number;
    sendToCenter: any[];
  }) =>
    userService.moveTeachers(
      {
        teacher_ids: teachers,
        center_attributes: sendToCenter,
      },
      centerId,
    );
  
  const updateTeacherPermissions = async (centerId: number, teacherId: number, body: any) => teacherService.updateTeacherPermissions(centerId, teacherId, body);

  return {
    updateTeacherPermissions,
    addTeacher,
    updateTeacher,

    getTeachers,
    addTeachers,
    editTeacher,
    deleteTeacher,
    getTeacherList,
    moveTeachers,
  };
}

export default useTeacher;
